import { Component, ElementRef, Input } from '@angular/core';
import { PosIntegrationService } from '../../../../../../services/pos-integration.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-teamwork-defaults',
  templateUrl: './teamwork-defaults.component.html',
  styleUrls: ['./teamwork-defaults.component.scss']
})
export class TeamworkDefaultsComponent {

  @Input() partner;
  public locations: any = [];
  public priceLevels: any = [];
  public defaults: any[];
  public config: any = {};
  public isEditing = -1;
  public message: string = null;
  constructor(private posIntegrationService: PosIntegrationService, private translate: TranslateService) { }

  ngOnInit() {
    this.getAll();
    this.getLocations(); 
    this.getPriceLevels();
    this.getConfig();
  }

  setEdit(index: number) {
    console.log(index);
    this.isEditing = index;
  }

  getAll() {
    console.log(this.partner.ID);
    this.posIntegrationService.getTaxOverrides(this.partner.ID).subscribe((data: any) => {
      this.defaults = data;
    });
  }

  getConfig() {
    this.posIntegrationService.getConfig(this.partner.ID).subscribe(
      (res) => {
        this.config = res;
        console.log(this.config);
      },
      (err) => {
      },
    );
  }

  getLocations() {
    this.posIntegrationService
      .getLocations(this.partner.ID)
      .subscribe((res) => {
        console.log(res);
        this.locations = res.map((x) => {
          return { label: x.Name, value: x.BikeShopSubscriptionId.toString() };
        });
        console.log(this.locations);
      });
  }

  getPriceLevels() {
    this.posIntegrationService
      .getPriceLevels(this.partner.ID)
      .subscribe((res) => {
        console.log(res);
        this.priceLevels = res.map((x) => {
          return { label: x.label, value: x.value };
        });
        console.log(this.locations);
      });
  }

  addDefault() {
    this.defaults = [...this.defaults, { CategoryID: '', Rate: '0', ID: 0 }];
    setTimeout(() => {
      var element: any = document.getElementById("tblData");
      var table = element.getElementsByTagName("table");
      var lastRow = table[0].rows[table[0].rows.length - 2];
      lastRow.getElementsByTagName("td")[0].click()
    }, 10);
  }

  removeDefault(index: number, row: any) {
    console.log(this.defaults[index]);
    this.posIntegrationService.deleteTaxOverrides(this.partner.ID, row.ID).subscribe((data: any) => {
      this.getAll();
    });
    this.defaults = this.defaults.filter((_, i) => i !== index);

  }

  saveDefault(row: any) {
    console.log(this.defaults);
    this.posIntegrationService.createTaxOverrides(this.partner.ID, row).subscribe((data: any) => {
      this.getAll();
      this.isEditing = -1;

    });


    this.message = this.translate.instant(
      'onboarding.pos_settings_updated',
    );
    setTimeout(() => {
      this.message = null;
    }, 2000);
  }

  updateConfig() {
    this.config.ID = this.partner.ID;
    this.config.StoreID = this.config.LocationID;
    this.config.PriceLevelID = this.config.PriceLevelID;
    this.posIntegrationService
      .updateConfig(this.partner.ID, this.config)
      .subscribe(
        (result) => {
        },
        (err) => {
        },
      );
  }
}
